import React from 'react';

import { Avatar } from '@mui/material';
import { grey } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 256
  },
  header: {
    padding: `4px ${24}px 0`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  avatar: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    transform: 'translateY(50%)',
    '& > img': {
      margin: 0,
      backgroundColor: 'white'
    }
  },
  divider: {
    backgroundColor: grey[200],
    marginBottom: 24 - 1 // minus 1 due to divider height
  },
  extra: {
    textTransform: 'uppercase',
    fontSize: 14,
    color: grey[500],
    letterSpacing: '1px'
  }
}));

const BrandCardHeader = ({ extra, image }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Avatar
          alt={' logo'}
          className={classes.avatar}
          src={image}
          sx={{ width: 60, height: 60 }}
        />
        {extra}
      </div>
      <hr className={classes.divider} />
    </div>
  );
};

BrandCardHeader.propTypes = {
  image: PropTypes.string,
  extra: PropTypes.string
};
BrandCardHeader.defaultProps = {
  image: '',
  extra: ''
};

export default BrandCardHeader;
